import React from 'react'
import{ FiUser, FiPhone, FiMapPin,  FiMap } from'react-icons/fi'
import{AboutItem} from './aboutItem'
import{users} from './mock'

export const AboutEdit = () => {
    const [user] = React.useState({
        company:{
            position:'Kernel Engineer',
            name:'ABC Corp'
        },
        school:{
            position:'C++ Programmar',
            name:'DFG Faculty'
        },
        phone:'0512 345 67 89',
        country:'Egypt',
        languages:[],
        email:'test@test.com',
        avatar:'assets/images/faces/1.png',
        first:'Tester',
        last:'Test',
        name:'test'

    })
    if(user){
    return (
        <div className="user__about__edit mb-3">
             <div className="">
                 <div className="heading">
                    <h4 className="head">About us</h4>
                </div>

                <div className="edit__cards">
                    <AboutItem title={user?.company?.position} desc={user?.company?.name} symbol={<FiPhone />} shortname={`${user?.first ? user.first.substring(0,1) +' '+ user.last.substring(0,1) : user.name.substring(0,1) }`} />
                    <AboutItem title={user?.school?.position} desc={user?.school?.name} symbol={<FiMap />}  />

                    {users.map((item, i) => {
                        return <div className="edit__card" key={i}> 
                                {item.shortname ? <div className="who shortname">{item.shortname}</div> : null}
                                {item.img && <div className="who"><img src={item.img} alt="" /></div>}
                                {!item.img && !item.shortname ? <div className="who">{item.symbol}</div> : null}

                                <div className="">
                                    {item.title && <div className="size-15">{item.title}</div>}
                                    <p className="desc">{item.desc}</p>
                                </div>
                        </div>
                    })}

                </div>
            </div>
        </div>
    )
    }else{
        return null;
    }

}